import React from 'react'

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="bg-white dark:bg-gray-800 shadow-sm rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
            Política de Privacidade
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-8">
            Última atualização: {new Date().toLocaleDateString('pt-BR')}
          </p>

          <div className="space-y-6 text-gray-700 dark:text-gray-300">
            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-3">
                1. Introdução
              </h2>
              <p className="mb-3">
                O ambcar é uma plataforma de gestão para concessionárias de veículos. Esta Política de
                Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações pessoais.
              </p>
              <p>
                Ao utilizar nossos serviços, você concorda com a coleta e uso de informações de acordo com esta
                política.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-3">
                2. Informações que Coletamos
              </h2>
              <p className="mb-2">Coletamos diferentes tipos de informações para fornecer e melhorar nosso serviço:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>
                  <strong>Informações de Cadastro:</strong> Nome, e-mail, telefone, CPF/CNPJ, endereço
                </li>
                <li>
                  <strong>Informações de Veículos:</strong> Dados dos veículos cadastrados (marca, modelo, placa, etc.)
                </li>
                <li>
                  <strong>Informações de Comunicação:</strong> Mensagens do WhatsApp Business, e-mails, interações com leads
                </li>
                <li>
                  <strong>Informações de Uso:</strong> Logs de acesso, endereço IP, tipo de navegador
                </li>
                <li>
                  <strong>Informações Financeiras:</strong> Dados de vendas, propostas e comissões
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-3">
                3. Como Utilizamos suas Informações
              </h2>
              <p className="mb-2">Utilizamos as informações coletadas para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Fornecer, manter e melhorar nossos serviços</li>
                <li>Processar transações e gerenciar sua conta</li>
                <li>Enviar notificações e atualizações importantes</li>
                <li>Analisar e melhorar a experiência do usuário</li>
                <li>Cumprir obrigações legais e regulatórias</li>
                <li>Prevenir fraudes e garantir a segurança da plataforma</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-3">
                4. Compartilhamento de Informações
              </h2>
              <p className="mb-2">
                Não vendemos suas informações pessoais. Podemos compartilhar suas informações apenas nas seguintes
                circunstâncias:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>
                  <strong>Provedores de Serviços:</strong> Meta/Facebook (WhatsApp Business API), Google Cloud Storage,
                  serviços de hospedagem
                </li>
                <li>
                  <strong>Conformidade Legal:</strong> Quando exigido por lei ou processo legal
                </li>
                <li>
                  <strong>Proteção de Direitos:</strong> Para proteger nossos direitos, privacidade, segurança ou
                  propriedade
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-3">
                5. Integrações com Terceiros
              </h2>
              <p className="mb-2">O ambcar integra-se com serviços de terceiros:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>
                  <strong>WhatsApp Business API (Meta):</strong> Para comunicação com leads via WhatsApp
                </li>
                <li>
                  <strong>Facebook Marketplace:</strong> Para publicação de veículos
                </li>
                <li>
                  <strong>Google Cloud Storage:</strong> Para armazenamento de imagens e arquivos
                </li>
              </ul>
              <p className="mt-3">
                Essas integrações estão sujeitas às políticas de privacidade dos respectivos provedores.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-3">
                6. Segurança dos Dados
              </h2>
              <p>
                Implementamos medidas de segurança técnicas e organizacionais para proteger suas informações pessoais
                contra acesso não autorizado, alteração, divulgação ou destruição. Isso inclui:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
                <li>Criptografia de dados em trânsito (HTTPS/TLS)</li>
                <li>Autenticação via JWT (JSON Web Tokens)</li>
                <li>Armazenamento seguro de tokens e credenciais</li>
                <li>Controle de acesso baseado em funções (RBAC)</li>
                <li>Monitoramento e logs de segurança</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-3">
                7. Retenção de Dados
              </h2>
              <p>
                Mantemos suas informações pessoais apenas pelo tempo necessário para cumprir os propósitos descritos
                nesta política, a menos que um período de retenção mais longo seja exigido ou permitido por lei.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-3">
                8. Seus Direitos (LGPD)
              </h2>
              <p className="mb-2">De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem direito a:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Confirmar a existência de tratamento de dados pessoais</li>
                <li>Acessar seus dados pessoais</li>
                <li>Corrigir dados incompletos, inexatos ou desatualizados</li>
                <li>Solicitar a anonimização, bloqueio ou eliminação de dados desnecessários</li>
                <li>Solicitar a portabilidade dos dados</li>
                <li>Revogar o consentimento</li>
                <li>Obter informações sobre compartilhamento de dados</li>
              </ul>
              <p className="mt-3">
                Para exercer esses direitos, entre em contato através do e-mail:{' '}
                <a href="mailto:privacy@myautohub.com" className="text-blue-600 dark:text-blue-400 hover:underline">
                  privacy@myautohub.com
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-3">
                9. Cookies e Tecnologias Similares
              </h2>
              <p>
                Utilizamos cookies e tecnologias similares para melhorar a experiência do usuário, analisar tendências
                e administrar a plataforma. Você pode controlar o uso de cookies através das configurações do seu
                navegador.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-3">
                10. Alterações nesta Política
              </h2>
              <p>
                Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos sobre quaisquer alterações
                publicando a nova política nesta página e atualizando a data de "Última atualização".
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-3">
                11. Contato
              </h2>
              <p className="mb-2">
                Se você tiver dúvidas sobre esta Política de Privacidade, entre em contato:
              </p>
              <ul className="list-none space-y-2 ml-4">
                <li>
                  <strong>E-mail:</strong>{' '}
                  <a href="mailto:privacy@myautohub.com" className="text-blue-600 dark:text-blue-400 hover:underline">
                    privacy@myautohub.com
                  </a>
                </li>
                <li>
                  <strong>Website:</strong>{' '}
                  <a
                    href="https://ambcar-frontend.vercel.app"
                    className="text-blue-600 dark:text-blue-400 hover:underline"
                  >
                    https://ambcar-frontend.vercel.app
                  </a>
                </li>
              </ul>
            </section>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
            <p className="text-sm text-gray-600 dark:text-gray-400 text-center">
              ambcar - Sistema de Gestão para Concessionárias
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
